// Attention!
// Do not edit directly! The hardcoded values of these tokens are token references
// that get resolved when the .js/d.ts files are being generated from the token JSON files.
export const SYS_BORDER_WIDTH_100 = '1px';
export const SYS_BORDER_WIDTH_200 = '2px';
export const SYS_BORDER_WIDTH_300 = '3px';
export const SYS_BORDER_WIDTH_FOCUS = '4px';
export const SEM_BORDER_WIDTH_FORMS_DEFAULT = '1px';
export const SEM_BORDER_WIDTH_FORMS_ACTIVE = '2px';
export const CMP_BORDER_WIDTH_FEEDBACK_PROGRESS_INDICATOR_SPINNER_SM = '1px';
export const CMP_BORDER_WIDTH_FEEDBACK_PROGRESS_INDICATOR_SPINNER_MD = '2px';
export const CMP_BORDER_WIDTH_FEEDBACK_PROGRESS_INDICATOR_SPINNER_LG = '3px';
export const CMP_BORDER_WIDTH_NOTIFCATION_UNDERLINE_DEFAULT = '1px';
//# sourceMappingURL=border-width.generated.js.map